import { render, staticRenderFns } from "./CreateBox.vue?vue&type=template&id=5926065d"
import script from "./CreateBox.vue?vue&type=script&lang=js"
export * from "./CreateBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports